import React, {useEffect, useState} from 'react';
import TextField from "../../../../../../../../ui/TextField";
import SquareButton from "../../../../../../../../ui/SquareButton";
import CheckIcon from "@material-ui/icons/Check";
import {withStyles} from "@material-ui/core/styles";
import Alert from "@material-ui/lab/Alert";
import DialogContent from "../../../../../../../../ui/Dialog/DialogContent";

const styles = theme => ({
  root: {
    width: "230px",
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "flex-end"
  }
});

export const QuestionScale = ({min, max, updateQuestionScale, updatedScale, setUpdatedScale, classes}) => {
  const [data, setData] = React.useState(
    { minValue: min, maxValue: max }
    );
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const onChange = (field, value) => {
    const newState = {
      ...data,
      [field]: value
    };
    setData(newState);
  };

  useEffect(() => {
    if (updatedScale !== null && updatedScale !== undefined) {
      if (updatedScale.success) {
        setSuccessMessage("Данные успешно сохранены");
        setErrorMessage(null);
      } else if (updatedScale.errors !== null && updatedScale.errors.length > 0) {
        let msg = updatedScale.errors.map(({message}) => message).join(", ");
        setErrorMessage(msg);
        setSuccessMessage(null);
      }
    } else {
      setErrorMessage(null);
      setSuccessMessage(null);
    }
  },[updatedScale]);

  useEffect(() => {
    if (successMessage !== null) {
      var t = setTimeout(() => {
        setSuccessMessage(null);
      },2000);
      return () => clearTimeout(t);
    }
  }, [successMessage]);

  return (<>{data && <div className={classes.root}>
      <TextField
        required
        value={data.minValue || 0}
        onChange={e => onChange("minValue", e.target.value)}
        label="от"
        style={{width: 80}}
      />
      <TextField
        required
        value={data.maxValue || 0}
        onChange={e => onChange("maxValue", e.target.value)}
        label="до"
        style={{width: 80}}
      />
      <SquareButton onClick={() => updateQuestionScale(data)}>
        <CheckIcon color={"action"}/>
      </SquareButton>
    </div>}
      {errorMessage !== null &&
      <Alert severity="error">{errorMessage}</Alert>}

      {successMessage !== null &&
      <Alert severity="success">{successMessage}</Alert>}
    </>
  )
}

export default withStyles(styles)(QuestionScale);
